module.exports = __webpack_public_path__ + "static/media/logo138x75white.f35a9c2b.png";